import './components/lucide.js'
// import Swiper JS
import Swiper from 'swiper/bundle';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Make Swiper globally available
window.Swiper = Swiper;

var MainServices = function () {
    "use strict";

    // Navigation Menu Toggle
    var initNavigation = function () {
        var $menuBtn = $('#menuBtn');
        var $mobileSidebar = $('#mobileSidebar');
        var $closeMenu = $('#closeMenu');

        $menuBtn.on('click', function () {
            $mobileSidebar.removeClass('translate-x-full').addClass('translate-x-0');
        });

        $closeMenu.on('click', function () {
            $mobileSidebar.addClass('translate-x-full').removeClass('translate-x-0');
        });
    };

    // Accordion (one open at a time + animated height)
    var initAccordion = function () {
        const items = Array.from(document.querySelectorAll(".accordion-item"));
        if (!items.length) return;

        function closeItem(el) {
            el.removeAttribute("open");
            const panel = el.querySelector(".accordion-panel");
            if (!panel) return;
            panel.style.height = panel.scrollHeight + "px";
            requestAnimationFrame(() => { panel.style.height = "0px"; });
        }

        function openItem(el) {
            el.setAttribute("open", "");
            const panel = el.querySelector(".accordion-panel");
            if (!panel) return;
            panel.style.height = "0px";
            const target = panel.scrollHeight;
            requestAnimationFrame(() => { panel.style.height = target + "px"; });
            panel.addEventListener("transitionend", function done(e) {
                if (e.propertyName !== "height") return;
                panel.style.height = "auto";
                panel.removeEventListener("transitionend", done);
            });
        }

        items.forEach((el) => {
            const summary = el.querySelector("summary");
            summary && summary.addEventListener("click", (e) => {
                e.preventDefault();
                const isOpen = el.hasAttribute("open");
                items.forEach(closeItem);
                if (!isOpen) openItem(el);
            });

            if (el.hasAttribute("open")) {
                const panel = el.querySelector(".accordion-panel");
                if (panel) panel.style.height = "auto";
            }
        });
    };

    // Swiper Initialization
    var initSwipers = function () {
        // Find all swiper containers that haven't been initialized
        const swiperContainers = document.querySelectorAll('.swiper:not(.swiper-initialized)');
        
        swiperContainers.forEach(container => {
            const swiperId = container.id;
            if (!swiperId) {
                console.warn('Swiper container found without an ID:', container);
                return;
            }
            
            // Get config from data attribute or use default
            const configData = container.getAttribute('data-swiper-config');
            let config = {};
            
            if (configData) {
                try {
                    const slideCount = container.querySelectorAll('.swiper-slide').length;
                    config = (new Function('slideCount', "return " + configData))(slideCount);
                    
                    // Disable loop if not enough slides
                    if (config.loop && slideCount <= (config.slidesPerView || 1)) {
                        console.warn(`Swiper loop disabled for ${swiperId}: not enough slides (${slideCount}) for loop mode`);
                        config.loop = false;
                    }
                } catch (e) {
                    console.warn('Invalid Swiper config:', e);
                }
            }
            
            // Initialize Swiper - PASS THE ELEMENT, NOT THE SELECTOR
            new Swiper(container, config);  // ✅ Changed from `#${swiperId}` to container
        });
    };

 

    
    // Public Init Function
    return {
        init: function () {
            console.log('MainServices.init() called');
            initNavigation();
            initAccordion();
            initSwipers();
        }
    };
}();

// Initialize Main Services
$(document).ready(function () {
    console.log('jQuery document ready fired');
    console.log('About to initialize MainServices...');
    MainServices.init();
    console.log('Main JS loaded with carousels and search initialized')
});